/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appOnelogin_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly oneloginEnabled: boolean | null;
        readonly oktaEnabled: boolean | null;
        readonly AADEnabled: boolean | null;
        readonly scimUsernamePassword: string | null;
        readonly oneloginClientId: string | null;
        readonly oneloginClientSecret: string | null;
        readonly oneloginUrl: string | null;
    } | null;
    readonly " $refType": "appOnelogin_viewer";
};
export type appOnelogin_viewer$data = appOnelogin_viewer;
export type appOnelogin_viewer$key = {
    readonly " $data"?: appOnelogin_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appOnelogin_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appOnelogin_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginClientSecret",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '9ace58736daff2a3de7dd2c73c4e7a43';
export default node;
